import { render, staticRenderFns } from "./parts-locations.vue?vue&type=template&id=3b51e5c8&scoped=true&"
import script from "./parts-locations.vue?vue&type=script&lang=js&"
export * from "./parts-locations.vue?vue&type=script&lang=js&"
import style0 from "./parts-locations.vue?vue&type=style&index=0&id=3b51e5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51e5c8",
  null
  
)

export default component.exports